import React, { useEffect, useState } from 'react';
import '../../App.css';
import './Naclo.css';
import { useAuth } from '../../contexts/AuthContext.js';
import { useNavigate } from 'react-router-dom';
import { getFirestoreData } from '../../firebase/Firestore.js'



const Naclo = () => {


    return (
        <div className="naclo-page">
            <div className="header-container">
                <img
                    src="/images/naclo-replacement 2 copy.png"
                    alt="Header"
                    className="naclo-header-image"
                />
                <div className= "naclo-text-container">
                    <h1 className="header-naclo-text">
                        North American Computational 
                    </h1>
                    <h1 className="header-naclo-text">
                        Linguistics Open Competition
                    </h1>
                </div>

            </div>
            <div className="banner">
                <p>Join us for NACLO!</p>
            </div>
            <div className="naclo-page-container">
            <div className="table-container">
                <img src="/images/campbell.PNG" alt="campbell" className="image" ></img>

                <div className="text">
                    <p><strong>This year Bruin Linguists Society at UCLA will be a testing site for the
                        <a href="https://naclo.org/"> North American Computational Linguistics Open Competition (NACLO). </a></strong></p>
                    <br></br>
                    <p> <strong> About Naclo </strong></p>
                    <p><i>NACLO is a fun contest for high-school and middle-school students who are interested in solving
                        linguistic puzzles. Through these puzzles, students are introduced to the diversity and consistency
                        of language, while exercising logic skills. No prior knowledge of linguistics or second languages is
                        necessary. Winners of NACLO are eligible to compete in the International Linguistics Olympiad.  Check out
                        the official website for registration, practice problems, and other regular updates.</i></p>
                    <br></br>
                    <p> <strong> How to Participate </strong></p>
                    <p><i>Student registration for NACLO 2027 is open! Register <a href="https://reg.naclo.org/"> here </a>, and check back on this page later for
                        more information on workshops we will be hosting.</i></p>
                </div>



            </div>
            </div>


        </div>
    );
};

export default Naclo;